import { render } from "./StoreDetails.vue?vue&type=template&id=7d3845a6"
import script from "./StoreDetails.vue?vue&type=script&lang=js"
export * from "./StoreDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__